import { navLinks, categories } from "@/mocks/observeData";

const focus = ["食品餐饮", "3C数码", "美妆个护", "零售消费", "金融保险", "汽车出行"];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.6fr_1fr_1fr_1.2fr]">
          <div>
            <a href="#top" className="inline-flex items-center gap-2.5 cursor-pointer">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-flashlight-line text-lg" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl font-black tracking-tight text-foreground-950">99黑料</span>
                <span className="mt-1 text-[11px] font-medium tracking-[0.12em] text-foreground-500">
                  舆情观察 · 消费避坑
                </span>
              </span>
            </a>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-foreground-600">
              追踪企业与品牌公开舆情与争议，坚持可溯源、重核实，帮你把信息辨明白，把消费看清楚。
            </p>
            <div className="mt-5 inline-flex items-center gap-2 rounded-md bg-background-50 px-3 py-2 text-xs text-foreground-600 ring-1 ring-background-200">
              <i className="ri-verified-badge-line text-accent-700" />
              编辑原则：无信源，不发布
            </div>
          </div>

          <nav aria-label="快速导航">
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-foreground-900">快速导航</h4>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="热门分类">
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-foreground-900">热门分类</h4>
            <ul className="mt-4 space-y-2.5">
              {focus.map((f) => (
                <li key={f}>
                  <a href="#category" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {f}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-foreground-900">免责与联系</h4>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              本站内容为公开信息整理与观察视角，供阅读参考，不代表对任何企业作出最终定论。
            </p>
            <a
              href="mailto:contact@99heihai.com"
              className="mt-4 inline-flex items-center gap-2 text-sm font-bold text-primary-700 hover:text-primary-800"
            >
              <i className="ri-mail-line" />
              contact@99heihai.com
            </a>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-center text-xs text-foreground-500 sm:text-left">
            © 2026 99黑料 · 本站所有内容为信息整理，转载须注明来源并保留核实状态说明。
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4 text-xs text-foreground-500">
            {categories.filter((c) => c.id !== "all").map((c) => (
              <a key={c.id} href="#topic" className="transition-colors hover:text-primary-600">
                {c.name}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}